module.exports = __webpack_public_path__ + "img/ajuda-card-04.f7dfe198.png";